import React from 'react';
import './protocol.less'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router-dom'
import { getAuth, getCheckinID, getVersion } from '@/util/storage'
import { Toast } from 'antd-mobile'
import { protocolAPI } from '@/api/protocol'
@(withRouter as any)
export default class Protocol extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            data: { store_name: '', customer_name: '', id_no: '', phone: '', room_bed_count: '', agreement_status: false },
            has_sign: false,
            sign_img: null,
            is_show: false
        }
    }

    UNSAFE_componentWillMount() {
        setHeader({
            title: '宿舍管理安全协议',
            leftClick: this.leftClick,
        })
    }

    componentWillMount() {
        this.fetchData()
    }

    leftClick() {
        //返回App
        if (window.WebViewBridge) {
            window.WebViewBridge.navBackMarket()
        } else if (window.webkit) {
            window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
    }

    async fetchData() {
        const auth = getAuth()
        const checkin_id = getCheckinID()
        const version = getVersion()
        const { data } = await protocolAPI({ auth, checkin_id, version })
        if (data.code === 'success') {
            this.setState({
                data: data.data.data,
                has_sign: data.data.has_sign,
                sign_img: data.data.sign_img,
                is_show: data.data.is_show
            })
        } else {
            Toast.show(data.msg, 1.5)
        }
    }

    safeSign() {
        if (window.WebViewBridge) {
            window.WebViewBridge.goToSignatureVC()
        } else if (window.webkit) {
            window.webkit.messageHandlers.goToSignatureVC.postMessage(null)
        }
    }

    render() {
        let model = this.state.data
        return (
            <div className="protocol-body">
                <div className="protocol-info">
                    <p className="font1">三一集团安全协议</p>
                    <p className="font3">甲方：三一集团 {model.store_name}</p>
                    <p className="font3">乙方：{model.customer_name}</p>
                    <p className="font3">身份证号码：{model.id_no}</p>
                    <p className="font3">联系电话：{model.phone}</p>
                    <p className="font3">入住房型{model.room_bed_count}人间，收费标准以合同或系统内费用为准。</p>

                    <p className="font2">一、甲、乙双方经友好协商，关于入住甲方公寓事宜达成以下协议：</p>
                    <p className="font3">1.甲方为乙方提供住宿服务。入住时间及收费标准按照甲方与乙方或乙方公司协议执行。</p>
                    <p className="font3">2.甲方对所提供房间（以下简称该房屋）及服务提供以下条件：高低床位、干净被褥，房间内配备空调及桌椅；甲方提供全天冷热水，配备公共卫生间、淋浴间（或独立卫生间）及其他双方任何的合理住宿设施和服务。</p>
                    <p className="font3">3.甲方有权要求乙方入住人员在入住期间遵守国家有关房屋使用和甲方公寓管理的各项安全制度，并配合甲方进行例行的安全检查。未征得甲方的书面同意，乙方不得擅自改变房间用途和房屋结构,并不得擅自转让或擅自留宿他人。</p>
                    <p className="font3">4.入住期间，乙方人员应当爱护并合理使用房间及公用设施，若因乙方在住人员使用不当或不合理而造成的损坏及故障，经乙方或乙方入住人员签字确认后，由甲方代为维修，费用由乙方或乙方入住人员承担。</p>
                    <p className="font3">5.甲乙双方约定：乙方的住宿费用由（乙方公司/乙方）支付，押金 200 元整。</p>

                    <p className="font2">二、安全条款：</p>
                    <p className="font3">为了做好三一集团安全管理工作，防止各类事故的发生，保障住宿人员人身、财产安全，根据治安消防法律法规和三一集团制度的有关规定，结合近年来的经验教训，特制定本安全责任书。责任人（住宿人）保证做到以下各项：</p>
                    <p className="font3">1.自觉遵守三一集团管理规定，尊重管理人员，服从管理，不能私自换床，如需换床应提前通知前台，并需支付 10 元/次的换床费，如不同意支付换床费，请办理退宿后重新办理入住。</p>
                    <p className="font3">2.禁止在该房屋内私接、私拉电线，公寓内不得私拉拖线板，如有发现，公寓管理人员将没收并处理；手机充电完毕后请拔掉充电器，不得遗留在插座上，查房人员发现将由公寓管理人员没收；公寓内不得使用大功率电器（如电饭锅、电热毯、电瓶车充电器等）如有发现，公寓人员将没收并处理；不得使用蜡烛、明火。上述情况发现三次（含 3 次）不改者，将被办理退房手续、扣除押金并请离公寓。</p>
                    <p className="font3">3.三一集团所有门店均为无烟区，所有人员在公寓范围内不得吸烟。一经发现罚款 200 元，如发现第三次，甲方有权勒令乙方或乙方入住人员退宿，并扣除乙方全部押金。</p>
                    <p className="font3">4.宿舍内如提供饮用水，只能作为日常饮用，不得挪作他用，如发现罚款 200 元，发现三次，甲方有权勒令乙方或乙方入住人员退宿，并扣除乙方全部押金。</p>
                    <p className="font3">5.乙方应积极主动参与消防知识、逃生知识、防盗知识的学习，并学有所用，做好该房屋内部的防火、防盗工作；乙方应养成良好的生活习惯，应于离开房屋时关闭电源、关紧窗、锁好门，贵重物品自行妥善保管或随身携带，不得留在公寓，若有遗失，甲方不承担责任。</p>
                    <p className="font3">6.乙方不得在该房屋内饲养宠物，不得打牌、奏乐器，不得在使用电视、网络、收音机等现在传媒工具时，影响他人的正常学习和休息；不在该房屋内参与起哄、高声喧哗、敲打物品等行为。</p>
                    <p className="font3">7.未经甲方同意，乙方不得在该房屋内留宿外来人员、不得窜房，一经发现罚款 200 元/人/次，同时，甲方有权勒令乙方退宿。</p>
                    <p className="font3">8.乙方不得组织、参与任何形式的赌博，不得酗酒，不得打架斗殴，不得砸酒瓶，不得破坏公共及他人财产，不得传播色情图片、视频、文字，不得捏造和传播虚假恐慌信息。</p>
                    <p className="font3">9.乙方禁止将易燃易爆物品带入该房屋，不得携带或私藏国家法律法规禁止的物品。</p>
                    <p className="font3">10.乙方不得利用该房屋从事经营活动，同时也不得允许他人利用该房屋从事经营活动；不得在宿舍摆摊设点，以免影响三一集团的正常管理秩序。</p>
                    <p className="font3">11.乙方须主动配合三一集团有关部门做好安全防范工作，发生火灾和治安事件及时报警。乙方应在以上公共安全管理中积极配合甲方的工作，甲方对违反安全的行为依法律法规及本协议严肃处理；若因乙方无法配合甲方严格安全管理而造成的协议争议、纠纷或协议中止及解除，其责任由乙方承担。同时，如因违反以上各条而造成一切财物损失及人身伤害损失，均由乙方承担。</p>

                    <p className="font2">三、其他条款：</p>
                    <p className="font3">1.本协议未尽事宜，经甲、乙双方协商一致，可订立补充条款。本协议补充条款及附件均为协议不可分割的一部分，本协议及其补充条款和附件内空格部分填写的文字与铅印文字具有同等效力。</p>
                    <p className="font3">2.甲、乙双方在签署本协议时，对各自的权利、义务、责任清楚明白，并愿按协议规定严格执行。</p>
                    <p className="font3">3.本协议连同附件一式两份。其中，甲、乙双方各持一份，均具有同等效力。</p>
                    {this.state.has_sign && <div>
                        <p className="font2">乙方签名：</p>
                        <img src={this.state.sign_img} height="200px" width="100%" v-if="has_sign === true" alt="签名" />
                    </div>}
                    {!this.state.has_sign && this.state.is_show && !model.agreement_status && <div className="btn" onClick={this.safeSign}>开始签名</div>}
                </div>
            </div>
        )
    }

}